export const diaMore = {
    en: {
        stats: [
            ["₹1,200", "Cost of one dialysis kit"],
            ["2", "Panchayats we serve: Mundur & Kongad"],
            ["1", "Own dialysis unit planned"],
        ],
        helpTitle: "How we help kidney patients",
        helpSub: "Support we already give, within the limits of our funds.",
        help: [
            ["Dialysis kits", "We give patients the supplies needed for a dialysis session. One kit costs ₹1,200."],
            ["Travel support", "We pay travel costs so patients can reach the dialysis facilities they depend on."],
            ["Help for serious cases", "We assist patients with serious kidney illness in Mundur, Kongad and nearby areas, as far as our funds allow."],
        ],
        whyTitle: "Why a centre close to home matters",
        whyText: "Dialysis is not a one-time treatment. Patients return again and again, and every trip to a far-away facility costs money, time and strength. Our own centre would let patients in Mundur, Kongad and nearby areas get treatment without travelling far.",
        whyPoints: [
            "Less travel for patients who are already weak",
            "Lower travel costs for poor families",
            "Care that stays close to home and family",
        ],
        roadTitle: "Our plan, step by step",
        road: [
            ["Today", "Dialysis kits and travel support for patients who need them."],
            ["Next", "Build our own dialysis unit so patients no longer travel far for treatment."],
            ["How it is funded", "Public donations and the trust's own funds."],
        ],
        helpUsTitle: "How you can help",
        helpUs: [
            ["Sponsor a kit", "Your ₹1,200 gives one patient the supplies for a dialysis session.", "Sponsor a kit"],
            ["Donate to the centre", "Every contribution brings our own dialysis unit closer. Bank details are on the Contact page.", "Donate now"],
            ["Call us", "Know a patient who needs help, or want to support in another way? Speak to us directly.", "Call the trust"],
        ],
        note: "Help is given within the limits of the trust's funds.",
    },
    ml: {
        stats: [
            ["₹1,200", "ഒരു ഡയാലിസിസ് കിറ്റിന്റെ വില"],
            ["2", "ഞങ്ങൾ സേവിക്കുന്ന പഞ്ചായത്തുകൾ: മുണ്ടൂർ, കോങ്ങാട്"],
            ["1", "ആസൂത്രണം ചെയ്യുന്ന സ്വന്തം ഡയാലിസിസ് പദ്ധതി"],
        ],
        helpTitle: "വൃക്കരോഗികളെ ഞങ്ങൾ എങ്ങനെ സഹായിക്കുന്നു",
        helpSub: "ഫണ്ടിന്റെ പരിധിക്കുള്ളിൽ ഇപ്പോൾ നൽകിവരുന്ന സഹായങ്ങൾ.",
        help: [
            ["ഡയാലിസിസ് കിറ്റുകൾ", "ഡയാലിസിസിന് ആവശ്യമായ സാമഗ്രികൾ രോഗികൾക്ക് നൽകുന്നു. ഒരു കിറ്റിന് ₹1,200 ചെലവ് വരും."],
            ["യാത്രാ സഹായം", "രോഗികൾക്ക് ആശ്രയിക്കുന്ന ഡയാലിസിസ് കേന്ദ്രങ്ങളിൽ എത്താൻ യാത്രാച്ചെലവ് നൽകുന്നു."],
            ["ഗുരുതര കേസുകൾക്ക് സഹായം", "മുണ്ടൂർ, കോങ്ങാട്, സമീപ പ്രദേശങ്ങളിലെ ഗുരുതര വൃക്കരോഗികളെ ഫണ്ടിന്റെ പരിധിയിൽ സഹായിക്കുന്നു."],
        ],
        whyTitle: "വീടിനടുത്ത് ഒരു പദ്ധതി എന്തുകൊണ്ട് പ്രധാനം",
        whyText: "ഡയാലിസിസ് ഒരിക്കൽ കഴിയുന്ന ചികിത്സയല്ല. രോഗികൾക്ക് വീണ്ടും വീണ്ടും പോകേണ്ടിവരും, ദൂരെയുള്ള കേന്ദ്രത്തിലേക്കുള്ള ഓരോ യാത്രയും പണവും സമയവും ആരോഗ്യവും ചെലവാക്കുന്നു. സ്വന്തം പദ്ധതി വന്നാൽ മുണ്ടൂർ, കോങ്ങാട്, സമീപ പ്രദേശങ്ങളിലെ രോഗികൾക്ക് ദൂരയാത്ര ഇല്ലാതെ ചികിത്സ ലഭിക്കും.",
        whyPoints: [
            "ഇതിനകം ക്ഷീണിതരായ രോഗികൾക്ക് യാത്ര കുറയുന്നു",
            "പാവപ്പെട്ട കുടുംബങ്ങൾക്ക് യാത്രാച്ചെലവ് കുറയുന്നു",
            "വീടിനും കുടുംബത്തിനും അടുത്തുതന്നെ പരിചരണം",
        ],
        roadTitle: "ഞങ്ങളുടെ പദ്ധതി, ഘട്ടം ഘട്ടമായി",
        road: [
            ["ഇന്ന്", "ആവശ്യമുള്ള രോഗികൾക്ക് ഡയാലിസിസ് കിറ്റുകളും യാത്രാ സഹായവും."],
            ["അടുത്തത്", "ചികിത്സയ്ക്കായി ദൂരയാത്ര വേണ്ടിവരാതിരിക്കാൻ സ്വന്തം ഡയാലിസിസ് പദ്ധതി സ്ഥാപിക്കുക."],
            ["ഫണ്ട് എങ്ങനെ", "പൊതുസംഭാവനകളും ട്രസ്റ്റിന്റെ സ്വന്തം ഫണ്ടും."],
        ],
        helpUsTitle: "നിങ്ങൾക്ക് എങ്ങനെ സഹായിക്കാം",
        helpUs: [
            ["ഒരു കിറ്റ് സ്പോൺസർ ചെയ്യൂ", "നിങ്ങളുടെ ₹1,200 ഒരു രോഗിക്ക് ഒരു ഡയാലിസിസിനുള്ള സാമഗ്രികൾ നൽകുന്നു.", "കിറ്റ് സ്പോൺസർ ചെയ്യൂ"],
            ["കേന്ദ്രത്തിനായി സംഭാവന", "ഓരോ സംഭാവനയും സ്വന്തം ഡയാലിസിസ് കേന്ദ്രത്തെ അടുപ്പിക്കുന്നു. ബാങ്ക് വിവരങ്ങൾ ബന്ധപ്പെടുക പേജിലുണ്ട്.", "സംഭാവന നൽകൂ"],
            ["ഞങ്ങളെ വിളിക്കൂ", "സഹായം വേണ്ട ഒരു രോഗിയെ അറിയാമോ, അല്ലെങ്കിൽ മറ്റ് വിധത്തിൽ പിന്തുണയ്ക്കണോ? നേരിട്ട് സംസാരിക്കൂ.", "ട്രസ്റ്റിനെ വിളിക്കൂ"],
        ],
        note: "ട്രസ്റ്റിന്റെ ഫണ്ടിന്റെ പരിധിക്കുള്ളിലാണ് സഹായം നൽകുന്നത്.",
    },
};